"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = once;

function once(fn) {
  var done;
  return function () {
    if (!done) {
      fn();
      done = 1;
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9vbmNlLnRzIl0sIm5hbWVzIjpbIm9uY2UiLCJmbiIsImRvbmUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBZSxTQUFTQSxJQUFULENBQWNDLEVBQWQsRUFBMEM7QUFDdkQsTUFBSUMsSUFBSjtBQUVBLFNBQU8sWUFBTTtBQUNYLFFBQUksQ0FBQ0EsSUFBTCxFQUFXO0FBQ1RELE1BQUFBLEVBQUU7QUFDRkMsTUFBQUEsSUFBSSxHQUFHLENBQVA7QUFDRDtBQUNGLEdBTEQ7QUFNRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIG9uY2UoZm46ICgpID0+IHZvaWQpOiAoKSA9PiB2b2lkIHtcbiAgbGV0IGRvbmU7XG5cbiAgcmV0dXJuICgpID0+IHtcbiAgICBpZiAoIWRvbmUpIHtcbiAgICAgIGZuKCk7XG4gICAgICBkb25lID0gMTtcbiAgICB9XG4gIH07XG59XG4iXX0=